import axios_ from "../utils/axios";
import qs from "qs";

/**
 * @param {("GET"|"get"|"POST"|"post")} method
 * @param {string} url
 * @param {Record<string,any>} params
 * @returns {{method: string, url: string, params: *, noCancelable: boolean, isFormData: boolean, isPyRequest: boolean, isFPyRequest: boolean}}
 */
function useConfig(method, url, params) {
  return {
    method,
    url,
    params,
    noCancelable: false,
    isFormData: false,
    isPyRequest: true,
    isFPyRequest: false,
  };
}

export default {
  // #region ----------------------------- 社交聆听 - 聆听任务 START --------------------------

  /**
   * 新建 社交聆听 主题
   * @param {string} topic_name 主题名称
   * @param {Array<string>} platform_list 媒体平台
   * @param {Array<string>} keywords_list 关键词
   * @param {Array<string>} target_country_list 目标国家
   * @param {Array<string>} target_language_list 目标语言
   * @returns {Promise<DefaultResponseType>}
   */
  create_topic(
    topic_name,
    platform_list,
    keywords_list,
    target_country_list = [],
    target_language_list = [],
    task_id = ""
  ) {
    return axios_(
      ...Object.values(
        useConfig("POST", "api/pandagpt/v1/social/create_topic", {
          topic_name,
          platform_list,
          keywords_list,
          target_country_list,
          target_language_list,
          task_id,
        })
      )
    );
  },

  /**
   * 获取 社交聆听 主题列表
   * @param {string} topic_name 搜索关键词
   * @param {string} page  分页页码
   * @param {string} page_number 分页条数
   * @returns {Promise<DefaultResponseType>}
   */
  get_topic_list(topic_name, page, page_number) {
    return axios_(
      ...Object.values(useConfig("GET", "api/pandagpt/v1/social/topic_list", { topic_name, page, page_number }))
    );
  },

  /**
   * 删除 社交聆听 主题列表
   * @param {string} task_id 主题 id
   * @returns {Promise<DefaultResponseType>}
   */
  delete_topic(task_id) {
    return axios_(...Object.values(useConfig("POST", "api/pandagpt/v1/social/delete_topic", { task_id })));
  },

  /**
   * 获取 社交聆听 主题概览
   * @param {string} task_id 任务id
   * @param {string} start_date 查询开始日期
   * @param {string} end_date 查询结束日期
   * @param {string} platform 平台
   * @param {string} country 国家
   * @param {string} language 语言
   * @returns {Promise<DefaultResponseType>}
   */
  get_topic_stat(task_id, start_date, end_date, platform = "", country = "", language = "") {
    return axios_(
      ...Object.values(
        useConfig("GET", "api/pandagpt/v1/social/topic_stat", {
          task_id,
          start_date,
          end_date,
          platform,
          country,
          language,
        })
      )
    );
  },

  /**
   * 获取 社交聆听  热门帖文
   * @param {number} page 当前页码
   * @param {number} page_num 每页帖文数
   * @param {number} topic_task_id 任务id
   * @param {string} start_date 查询开始日期
   * @param {string} end_date 查询结束日期
   * @param {number} platform 平台
   * @param {string} country_code 国家
   * @param {string} language 语言
   * @returns {Promise<DefaultResponseType>}
   */
  get_top_content(
    page,
    page_num,
    topic_task_id,
    start_date,
    end_date,
    platform = "",
    country_code = "",
    language = "",
    keywords = []
  ) {
    return axios_(
      ...Object.values(
        useConfig("POST", "api/pandagpt/v1/social/top_content", {
          page,
          page_num,
          topic_task_id,
          start_date,
          end_date,
          platform,
          country_code,
          language,
          keywords,
        })
      )
    );
  },

  /**
   * 话题分析
   * @param {number} topic_task_id 任务id
   * @param {string} start_date 查询开始日期
   * @param {string} end_date 查询结束日期
   * @param {number} platform 平台
   * @param {string} country_code 国家
   * @param {string} language 语言
   * @param {Array} keywords 关键词列表
   * @returns {Promise<DefaultResponseType>}
   */
  topic_analyze(task_id, start_date, end_date, platform = "", country = "", language = "") {
    return axios_(
      ...Object.values(
        useConfig("GET", "api/pandagpt/v1/social/topic_analyze", {
          task_id,
          start_date,
          end_date,
          platform,
          country,
          language,
        })
      )
    );
  },

  /**
   * 话题洞察
   * @param {number} topic_task_id 任务id
   * @param {string} start_date 查询开始日期
   * @param {string} end_date 查询结束日期
   * @param {number} platform 平台
   * @param {string} country_code 国家
   * @param {string} language 语言
   * @param {Array} keywords 关键词列表
   * @returns {Promise<DefaultResponseType>}
   */
  topic_insight(
    task_id,
    start_date,
    end_date,
    platform = "",
    country = "",
    language = "",
    sort_field = "",
    sort_order = "desc"
  ) {
    return axios_(
      ...Object.values(
        useConfig("GET", "api/pandagpt/v1/social/topic_insight", {
          task_id,
          start_date,
          end_date,
          platform,
          country,
          language,
          sort_field,
          sort_order,
        })
      )
    );
  },

  /**
   * 获取 社交聆听 主题内容
   * @param {string} task_id 任务id
   * @param {string} start_date 查询开始日期
   * @param {string} end_date 查询结束日期
   * @param {string} platform 平台
   * @param {string} country 国家
   * @param {string} language 语言
   * @returns {Promise<DefaultResponseType>}
   */
  get_topic_content(task_id, start_date, end_date, platform = "", country = "", language = "") {
    return axios_(
      ...Object.values(
        useConfig("GET", "api/pandagpt/v1/social/topic_content", {
          task_id,
          start_date,
          end_date,
          platform,
          country,
          language,
        })
      )
    );
  },

  /**
   * 获取 社交聆听 主题作者
   * @param {string} task_id 任务id
   * @param {string} start_date 查询开始日期
   * @param {string} end_date 查询结束日期
   * @param {string} platform 平台
   * @param {string} country 国家
   * @param {string} language 语言
   * @returns {Promise<DefaultResponseType>}
   */
  get_topic_author(task_id, start_date, end_date, platform = "", country = "", language = "") {
    return axios_(
      ...Object.values(
        useConfig("GET", "api/pandagpt/v1/social/topic_author", {
          task_id,
          start_date,
          end_date,
          platform,
          country,
          language,
        })
      )
    );
  },

  /**
   * 获取 社交聆听 主题对话
   * @param {string} task_id 任务id
   * @param {string} start_date 查询开始日期
   * @param {string} end_date 查询结束日期
   * @param {string} platform 平台
   * @param {string} country 国家
   * @param {string} language 语言
   * @returns {Promise<DefaultResponseType>}
   */
  get_topic_dialog(task_id, start_date, end_date, platform = "", country = "", language = "") {
    return axios_(
      ...Object.values(
        useConfig("GET", "api/pandagpt/v1/social/topic_dialog", {
          task_id,
          start_date,
          end_date,
          platform,
          country,
          language,
        })
      )
    );
  },

  // #endregion -------------------------- 社交聆听 - 聆听任务 END ----------------------------

  // #region ----------------------------- 社交聆听 - 聆听对比 START --------------------------
  /**
   * 获取 社交聆听 数据对比列表
   * @param {number} task_name 任务名称
   * @returns {Promise<DefaultResponseType>}
   */
  get_compare_list(task_name, page, page_number) {
    return axios_(
      ...Object.values(useConfig("GET", "api/pandagpt/v1/social/compare_list", { task_name, page, page_number }))
    );
  },

  /**
   * 删除 社交聆听 对比
   * @param {number} task_id 主题id
   * @returns {Promise<DefaultResponseType>}
   */
  delete_compare(task_id) {
    return axios_(...Object.values(useConfig("POST", "api/pandagpt/v1/social/delete_compare", { task_id })));
  },

  /**
   * 新建 社交聆听 对比任务
   * @param {string} task_name 任务名称
   * @param {number} topic_task_id 目标主题id
   * @param {Array<number>} compared_topic 对比主题id
   * @param {Array<number>} compare_task_id 对比任务id
   * @returns {Promise<DefaultResponseType>}
   */
  compare_task(task_name, topic_task_id, compared_topic, compare_task_id = []) {
    return axios_(
      ...Object.values(
        useConfig("POST", "api/pandagpt/v1/social/compare_task", {
          task_name,
          topic_task_id,
          compared_topic,
          compare_task_id,
        })
      )
    );
  },

  /**
   * 获取 社交聆听 对比详情
   * @param {Array<string>} task_ids 任务id列表
   * @returns {Promise<DefaultResponseType>}
   */
  get_compare_detail(task_ids) {
    return axios_(
      ...Object.values(
        useConfig("POST", "api/pandagpt/v1/social/compare_detail", {
          task_ids,
        })
      )
    );
  },

  // #endregion -------------------------- 社交聆听 - 聆听对比 END ----------------------------

  // #region ----------------------------- 受众分析 START --------------------------
  /**
   * 新增受众任务
   * @param {string} task_name 任务名称
   * @param {string} start_date 开始日期
   * @param {string} end_date 结束日期
   * @param {string} page_id 主页id
   * @param {string} page_name 主页名称
   * @param {number} platform 平台
   * @returns {Promise<DefaultResponseType>}
   */
  create_audiences_task(task_name, start_date, end_date, page_id, page_name, platform, task_id) {
    return axios_(
      ...Object.values(
        useConfig("POST", "api/pandagpt/v1/social/audiences_task", {
          task_name,
          start_date,
          end_date,
          page_id,
          page_name,
          platform,
          task_id,
        })
      )
    );
  },

  /**
   * 获取受众ai分析数据
   * @param {string} audiences_task_id 受众任务id
   * @returns {Promise<DefaultResponseType>}
   */
  get_audiences_analyze(audiences_task_id) {
    return axios_(
      ...Object.values(
        useConfig("GET", "api/pandagpt/v1/social/audiences_analyze", {
          audiences_task_id,
        })
      )
    );
  },

  /**
   * 获取数据对比列表
   * @param {string} audiences_task_id 受众任务id
   * @returns {Promise<DefaultResponseType>}
   */
  get_audiences_detail(audiences_task_id) {
    return axios_(
      ...Object.values(
        useConfig("GET", "api/pandagpt/v1/social/audiences_detail", {
          audiences_task_id,
        })
      )
    );
  },

  /**
   * 获取受众任务列表
   * @param {Object} params 参数
   * @returns {Promise<DefaultResponseType>}
   */
  get_audiences_list(params) {
    return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/social/audiences_list", params)));
  },

  /**
   * 获取 受众用户列表
   * @param {Object} params 参数对象
   * @param {string} params.task_id 任务ID
   * @param {number} params.page 页码
   * @param {number} params.page_size 每页大小
   * @returns {Promise<DefaultResponseType>}
   */
  get_audiences_user_list(params) {
    return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/social/audiences_user_list", params)));
  },

  /**
   * 删除 受众任务
   * @param {string} task_id 任务ID
   * @returns {Promise<DefaultResponseType>}
   */
  delete_audience(task_id) {
    return axios_(...Object.values(useConfig("POST", "api/pandagpt/v1/social/delete_audience", { task_id })));
  },
  // #endregion -------------------------- 受众分析 END ----------------------------

  /**
   * 获取 社交聆听 国家列表
   * @returns {Promise<DefaultResponseType>}
   */
  get_country_language() {
    return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/social/country_language", {})));
  },
};
